import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { DialogComponent } from '../component/dynamic-form/dialog-box/dialog-component';

/**
 * Centralized notification service to handle translated snackbar and dialog messages.
 * Eliminates duplication across components.
 */
@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private translate: TranslateService,
  ) {}

  /**
   * Show a translated snackbar notification
   * @param messageKey - Translation key from en.json
   * @param duration - Display duration in milliseconds
   * @param panelClass - Optional CSS classes for styling
   */
  showSnack(messageKey: string, duration: number, panelClass?: string[]): void {
    this.translate.get(messageKey).subscribe((res: string) => {
      this.snackBar.open(res, 'Close', {
        duration,
        panelClass,
      });
    });
  }

  /**
   * Show a translated dialog with a message
   * @param messageKey - Translation key from en.json
   */
  showDialog(messageKey: string): void {
    this.translate.get(messageKey).subscribe((res: string) => {
      this.dialog.open(DialogComponent, {
        data: { message: res },
      });
    });
  }
}
